import React, { useState } from "react";
import Swal from "sweetalert2";
import { Link } from 'react-router-dom';
import { createDemoraAnticipada } from "../../../../../helpers/Api";
import FileUploader from "../../../../../helpers/FileUploader";

const DemAnticipada = ({ 
  token, 
  idSolicitud, 
  idContenedor, 
  closeModal,
  dataEir, 
}) => {

  const BASE_URL = process.env.REACT_APP_API;
  const role = localStorage.getItem('role');
  const [file, setFile] = useState('');
  const [showDragZone, setShowDragZone] = useState(false); 

  const dataEirCounterKey =  dataEir?.archivo_demoras_anticipadas.split('/').length - 1
  const dataEirFileRoute = dataEir?.archivo_demoras_anticipadas.split('/')[dataEirCounterKey]

  const handlerCreateDemoraAnticipada = async () => {

    try {
      const response = await createDemoraAnticipada(
        idSolicitud, 
        idContenedor, 
        {archivo_demoras_anticipadas : file }, token);
      if (response === 200) { 
        Swal.fire("Exito", "El archivo de demoras anticipadas fue creado con éxito", "success");
        closeModal();
       
      }
    } catch (error) {
      Swal.fire("Oops", "Ha surgido un error", "error");
    }
  };

  const downLoadDemorasAnticipadas = (fileName) => {
    fetch(`${BASE_URL}/media/${fileName}`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}`;
        a.click();
      });
    });
  };

  return (
    <>
      <div className="row d-flex justify-content-center">
        <div className="col-8">
          <h6 className='mb-5'>{dataEir?.archivo_demoras_anticipadas ? 'Esta es la información guardada de la etapa de Demora anticipada' : 'Ingrese la información requerida referente a las demoras anticipadas'}</h6>
        </div> 
        {dataEir.archivo_demoras_anticipadas ?
        <div className='col-8 mt-1 mb-3' >
          <p>Archivo de demora anticipada guardado:</p>
          <button className="btn btn-link"  type='button' onClick={() => downLoadDemorasAnticipadas(dataEir.archivo_demoras_anticipadas)}>{dataEirFileRoute}</button> 
          { role === 'AGA' ?
          <button className='btn btn-outline-primary' onClick={() => setShowDragZone(true)} style={{marginLeft: '20px'}}>Sustituir archivo</button> 
          :
          null
          }
        </div> 
        :
        <>
        <div className="col-10 mt-5">
          <FileUploader
          setFile={setFile}
          idSolicitud={idSolicitud} 
          idContenedor={idContenedor} 
          token={token}
        />
        </div> 
        <div className="col-8 d-flex flex-row-reverse mt-4">
          <button onClick={() => handlerCreateDemoraAnticipada()} className="btn btn-primary">Guardar</button> 
        </div>
        </>
        }
        {showDragZone && 
        <>
        <div className="col-10 mt-5">
          <FileUploader
          setFile={setFile}
          idSolicitud={idSolicitud} 
          idContenedor={idContenedor} 
          token={token}
        />
        </div> 
        <div className="col-8 d-flex flex-row-reverse mt-4">
          <button onClick={() => handlerCreateDemoraAnticipada()} className="btn btn-primary">Guardar</button> 
        </div>
        </>
        }
       
      </div>
    </>
  );
};

export default DemAnticipada;
